import React from "react";

const features = [
  {
    icon: "https://www.earthytales.in/uploads/icons/f1.webp?v=1609202504",
    text: "Trusted By Over",
    strong: "12,000+ Families",
  },
  {
    icon: "https://www.earthytales.in/uploads/icons/f3.webp?v=1609202504",
    text: "Connected To 500+",
    strong: "Organic Kisan",
  },
  {
    icon: "https://www.earthytales.in/uploads/icons/f2.webp?v=1609202504",
    text: "25 Tons",
    strong: "Pesticides Avoided",
  },
];

const FeatureBlock = () => {
  return (
    <>
      <style>{`
        .feature-section {
          background-color: var(--color-accent);
          padding: var(--space-lg) var(--space-md);
          text-align: center;
        }

        .feature-section .heading {
          font-size: var(--font-xl);
          font-weight: 700;
          color: var(--color-primary);
          margin-bottom: var(--space-md);
          font-family: var(--font-primary);
        }

        .features {
          display: flex;
          justify-content: center;
          gap: var(--space-lg);
          flex-wrap: wrap;
        }

        .feature-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 200px;
        }

        .feature-item img {
          width: 60px;
          height: 60px;
          margin-bottom: var(--space-xs);
        }

        .feature-item p {
          font-size: var(--font-base);
          color: var(--color-primary);
          margin: 0;
          line-height: 1.5;
        }

        .feature-item strong {
          font-weight: 700;
          display: block;
          margin-top: var(--space-xs);
        }

        @media (max-width: 768px) {
          .features {
            gap: var(--space-md);
          }
        }

        @media (max-width: 480px) {
          .feature-item img {
            width: 50px;
            height: 50px;
          }
          .feature-item p {
            font-size: var(--font-sm);
          }
        }
      `}</style>

      <section className="feature-section py-5">
        <div className="container py-3">
          <h2 className="heading py-3">अच्छा अन्न, अच्छा तन, अच्छा मन ®</h2>
          <div className="features">
            {features.map((item, index) => (
              <div key={index} className="feature-item">
                <img src={item.icon} alt={item.strong} />
                <p>
                  {item.text} <br />
                  <strong>{item.strong}</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FeatureBlock;
